export const DATE_WITH_TIME_FORMAT = 'DD MMM YYYY HH:mm'
